import React, {useState, useEffect, useRef} from 'react'
import Toggle from "../widgets/Toggle";
import {useApi} from "../ApiSession";
import {DefaultButton} from "../widgets/Buttons";
import {command} from "../rest";

export const Task = ({task, pipelineInstance, onCloseClick}) => {

    const is_slurm_parent = task.is_slurm_parent

    const [latestTask, setLatestTask] = useState(task)

    const [activeTab, setActiveTab] = useState(is_slurm_parent ? "tasksInArray": "logs")

    const [isAutoRefresh, setIsAutoRefresh] = useState(false)

    const [refreshButtonCaption, setRefreshButtonCaption] = useState("Refresh State and Logs")

    const [restartButtonCaption, setRestartButtonCaption] = useState("Restart Failed")

    const api = useApi()

    const refreshTask = () =>
        api.getTask(pipelineInstance.pid, latestTask.task_key).then(res => {
            setLatestTask(res)
        })

    useEffect(() => {
        let interval;

        if (isAutoRefresh) {
            interval = setInterval(refreshTask, 5000)
        }
        return () => clearInterval(interval)
      }, [isAutoRefresh])

    const restartFailed = () =>
        api.restartTask(pipelineInstance.pid, {taskKey: latestTask.task_key}).then(res => {
            refreshTask().then(() => {
                setIsAutoRefresh(true)
            })
        })

    const resetAndRerun = () => {
        setRestartButtonCaption("...restarting Failed Tasks")
        api.restartTask(pipelineInstance.pid, {taskKey: latestTask.task_key, reset: true}).then(res => {
            refreshTask().then(() => {
                setIsAutoRefresh(true)
                setRestartButtonCaption("Restart Failed")
            })
        })
    }

    const refreshStateAndLogs = () => {
        setRefreshButtonCaption("...refreshing Logs and State")
        api.command(pipelineInstance.pid, 'fetch-remote-state', {
            '--task-key': task.task_key,
            '--wait': null
        }).then(res => {
            refreshTask().then(res2 => {
                setRefreshButtonCaption("Refresh State and Logs")
            })
        })
    }


    const renderArrayRestartButtonIfApplicable = () => {

        if(!is_slurm_parent) {
            return null
        }

        const canRestart = is_slurm_parent && latestTask.restartable_count > 0

        return <DefaultButton caption={restartButtonCaption} isDisabled={!canRestart} onClick={restartFailed}/>
    }

    const renderTaskRestartButtonsIfApplicable = () => {
        if(is_slurm_parent) {
            return null
        }

        const canRestart =
            latestTask.state.indexOf("failed") !== -1 ||
            latestTask.state.indexOf("killed") !== -1 ||
            latestTask.state.indexOf("timed-out") !== -1

        const canReset =
            canRestart || latestTask.state.endsWith("completed") !== -1

        return <>
            <DefaultButton caption={"Reset and Rerun"} isDisabled={!canReset} onClick={resetAndRerun}/>
            <DefaultButton caption={"Restart Failed"} isDisabled={!canRestart} onClick={restartFailed}/>
        </>
    }

    const toggleAutoRefresh = () => {
        const newValue = !isAutoRefresh
        setIsAutoRefresh(newValue)
        if(newValue) {
            refreshTask()
        }
    }

    const renderActiveTab = () => {
        switch (activeTab) {
            case "logs":
                return <div className="grid grid-cols-2 gap-4">
                    <div>
                        <Console label={"out.log"} text={latestTask.out}/>
                    </div>
                    <div>
                        <Console label={"drypipe.log"} text={latestTask.drypipe_log}/>
                    </div>
                </div>
            case "configs":
                return <div className="grid grid-cols-1 gap-4">
                    <div>
                        <Console label={"task-conf.json"} text={JSON.stringify(latestTask.task_conf, null, 2)}/>
                    </div>
                </div>
            case "tasksInArray":
                return <div>
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead></thead>
                        <tbody>
                        {latestTask.children.map((t, idx) =>
                            <tr
                                className={"bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600"}
                                key={t.key}>
                                <td>{idx}</td>
                                <td>{t.key}</td>
                                <td>{t.state}</td>
                            </tr>)
                        }
                        </tbody>

                    </table>
                </div>
        }
    }


    return <>
        <div className={"grid grid-cols-2"}>
            <div className={"flex justify-start p-4"}>
                <div>Task( key = {latestTask.task_key} )</div>
                <div>[{latestTask.state}]</div>
            </div>
            <div className={"flex justify-end p-4 gap-3"}>
                <Toggle
                    label={"auto refresh"}
                    value={isAutoRefresh}
                    onChange={toggleAutoRefresh}
                />
            </div>
        </div>
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <Tabs
                task={task}
                activeTab={activeTab}
                onSelectTab={tabName => setActiveTab(tabName)}
            />
            <div className="p-4 md:p-5 space-y-4">
                {renderActiveTab()}
            </div>

            <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                <DefaultButton caption={"Close"} onClick={() => onCloseClick()}/>
                { renderArrayRestartButtonIfApplicable() }
                { renderTaskRestartButtonsIfApplicable() }
                <DefaultButton caption={refreshButtonCaption} onClick={refreshStateAndLogs}/>
            </div>
        </div>
    </>
}


const Tabs = ({task, activeTab, onSelectTab}) => {


    const IconLogs = ({extraClass}) =>
        <svg className={"w-6 h-6 " + extraClass} aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
             width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M6 6h8m-8 4h12M6 14h8m-8 4h12"/>
        </svg>

    const IconConfigs = ({extraClass}) =>
        <svg className={"w-6 h-6 "+ extraClass} aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
             width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeWidth="2"
                  d="M20 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6h-2m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4"/>
        </svg>


    const AClassIf = bool =>
        bool ?
            `active inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg dark:text-blue-500 dark:border-blue-500 group` :
            `inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group`


    const IconClassIf = bool =>
        bool ?
            `text-blue-600 dark:text-blue-500` :
            `text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300`


    return <div className="border-b border-gray-200 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            {
                task.is_slurm_parent && <li className="me-2">
                <a href="#"
                   onClick={() => onSelectTab("tasksInArray")}
                   className={AClassIf(activeTab === "tasksInArray")}
                >
                    Tasks in Array
                </a>
            </li>
            }
            <li className="me-2">
                <a href="#"
                   onClick={() => onSelectTab("logs")}
                   className={AClassIf(activeTab === "logs")}
                >
                    <IconLogs extraClass={IconClassIf(activeTab === "logs")}/>
                    Logs
                </a>
            </li>
            <li className="me-2">
                <a href="#"
                   className={AClassIf(activeTab === "configs")}
                   onClick={() => onSelectTab("configs")}
                >
                    <IconConfigs extraClass={activeTab === "configs"}/>
                    Config
                </a>
            </li>
        </ul>
    </div>
}


const useTailLikeScrollToBottom = text => {

    const textAreaRef = useRef()

    useEffect(() => {
        if (textAreaRef.current && document.activeElement !== textAreaRef.current) {
            textAreaRef.current.scrollTop = textAreaRef.current.scrollHeight
        }
    }, [text])

    return textAreaRef
}


const Console = ({label, text}) => {

    const consoleText = useTailLikeScrollToBottom(text)

    return <>
        <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            {label}
        </label>
        <textarea
            ref={consoleText}
            style={{caretColor: "transparent", height: 500}}
            className="bg-black block p-2.5 w-full text-sm text-lime-400 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            value={text || ''}
            readOnly={true}
        ></textarea>
    </>
}